import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

export default function LegalMentions() {
  return (
    <div className="relative min-h-screen text-black overflow-hidden bg-white">
      <NavBar />

      <section className="px-6 pt-6 pb-2">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-semibold leading-tight">Mentions Légales</h1>
          <p className="mt-3 text-sm text-gray-600">En vigueur au 10/08/2025</p>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="max-w-3xl mx-auto space-y-8 text-[15px] leading-7">

          <p>
            Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l'économie
            numérique, il est porté à la connaissance des utilisateurs du site <span className="font-medium">pacte-claix.fr</span>,
            ci-après le «&nbsp;Site&nbsp;», les présentes mentions légales.
          </p>

          <p>
            La connexion et la navigation sur le Site par l’Utilisateur impliquent acceptation intégrale et sans réserve
            des présentes mentions légales. Celles-ci sont accessibles sur le Site à la rubrique «&nbsp;Mentions légales&nbsp;».
          </p>

          <section>
            <h2 className="text-xl font-semibold mb-2">Éditeur du Site</h2>
            <p>
              Le Site est édité par l’<span className="font-semibold">Association PACTE (PROMOUVONS NOS ACTEURS CLAIXOIS TOUS ENSEMBLE)</span> (loi 1901), déclarée à la préfecture.
            </p>
            <p className="mt-3">
              RNA &nbsp;: <span className="font-medium">W381029234</span><br/>
              SIREN &nbsp;: <span className="font-medium">941 942 856</span><br/>
              Siège social&nbsp;: <span className="font-medium">106 ARBOREA, 2 RUE AIME SERRES, 38640 Claix, France</span><br/>
              Téléphone&nbsp;: <span className="font-medium">[+33 X XX XX XX XX]</span><br/>
              E-mail&nbsp;: <a href="mailto:contact@pacte-claix.fr" className="underline">contact@pacte-claix.fr</a>
            </p>
            <p className="mt-3">
              Directeur de la publication&nbsp;: <span className="font-medium">FAURE Kinan, Président de l’association</span>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Hébergeur</h2>
            <p>
              L’hébergeur du Site est la société <span className="font-medium">LWS (Ligne Web Services)</span>, 4&nbsp;rue Galvani, 75017 Paris, France.
            </p>
            <p className="mt-3">
              Téléphone&nbsp;: +33&nbsp;1&nbsp;77&nbsp;62&nbsp;30&nbsp;03 — Site&nbsp;:{" "}
              <a className="underline" href="https://www.lws.fr" target="_blank" rel="noreferrer">www.lws.fr</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Crédits</h2>
            <p>
              Conception &amp; développement&nbsp;: <span className="font-medium">NOXZI EURL</span> (RCS Chambéry&nbsp;990&nbsp;027&nbsp;377).{" "}
              Site&nbsp;: <a href="https://noxzi.fr" target="_blank" rel="noreferrer" className="underline">noxzi.fr</a>
            </p>
            <p className="mt-3">
              Les illustrations, photos et logos restent la propriété de leurs titulaires respectifs. Toute reproduction est interdite sans autorisation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Accès au Site</h2>
            <p>
              Le Site est normalement accessible à tout moment. L’Éditeur peut toutefois suspendre, limiter ou interrompre l’accès afin de procéder à des mises à jour ou modifications.
              La responsabilité de l’Éditeur ne saurait être engagée en cas d’indisponibilité.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Propriété intellectuelle</h2>
            <p>
              L’ensemble des contenus (textes, images, photographies, logos, vidéos, etc.) est protégé par le droit de la propriété intellectuelle.
              Toute reproduction, représentation, diffusion ou modification, totale ou partielle, sans autorisation préalable est interdite.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Liens et cookies</h2>
            <p>
              Le Site peut contenir des liens vers des sites tiers. L’Éditeur n’exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leurs contenus.
            </p>
            <p className="mt-3">
              Pour plus d’informations sur les cookies et vos choix, veuillez consulter nos{" "}
              <Link to="/cgu" className="underline">Conditions Générales d’Utilisation</Link>{" "}
              et, le cas échéant, notre <Link to="/politique-de-cookies" className="underline">Politique de cookies</Link>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Données personnelles (RGPD)</h2>
            <p>
              Les données collectées via le Site sont traitées par l’Association PACTE afin de gérer les demandes et le suivi de la relation avec les usagers.
              Conformément au RGPD et à la loi «&nbsp;Informatique et Libertés&nbsp;», vous disposez d’un droit d’accès, de rectification, d’effacement, de limitation, d’opposition et de portabilité.
              Vous pouvez exercer vos droits à l’adresse&nbsp;:{" "}
              <a href="mailto:contact@pacte-claix.fr" className="underline">contact@pacte-claix.fr</a>.
            </p>
            <p className="mt-3">
              Délégué à la protection des données (le cas échéant)&nbsp;: <span className="font-medium">[Nom / «&nbsp;Non désigné&nbsp;»]</span>.{" "}
              Pour en savoir plus, consultez notre{" "}
              <Link to="/politique-de-confidentialite" className="underline">Politique de confidentialité</Link>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Responsabilité</h2>
            <p>
              L’Éditeur met tout en œuvre pour assurer l’exactitude et la mise à jour des informations diffusées sur le Site.
              Il ne saurait toutefois être tenu responsable des erreurs, omissions ou d’une indisponibilité du service.
            </p>
          </section>

        </div>
      </section>

      <Footer />
    </div>
  );
}